export default __webpack_public_path__ + "db489432b703106aaa6314c4440bc309.png";